"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tsenum_1 = require("@gradecam/tsenum");
exports.ObfuscationTarget = tsenum_1.MakeEnum({
    Browser: 'browser',
    BrowserNoEval: 'browser-no-eval',
    Node: 'node'
});
